module.exports = __webpack_public_path__ + "static/media/A_lazy_ux.e62e63cc.png";